import birds from '../images/birds.png'
import '../../App.scss';

export default function aboutMERL() {
    return (
		<div className='gray-primary flex-col align-left gap-24 section-header'>
			{/* <div className="flex-row gap-12">
				<span class="dot red"></span>
				<h1>About MERL</h1>
			</div> */}
			<h1 className='text-white'>What is MERL?</h1>
			<div className="flex-item gap-64">
				<img src={birds} alt="" id='home-birds' ></img>
				<div className='flex-col align-left text-white gap-24'>
					<h1 className='text-white' id='aboutCallout'>Media Education Research Lab</h1>
					<p className='text-white'>The Media Education Research Lab (MERL, rhymes with “pearl”) is a UC Berkeley-based research lab founded and led by Professor Abigail De Kosnik.</p>
					<p className='text-white'>Since 2020, MERL has worked to develop a method for measuring and representing the quantity and quality of diversity in popular media. We call our method “MERL Diversity Scores.”</p>
					<a href={"/scoring"}><button className="button pink" to={"/scoring"}>Read about the Diversity Scores system &gt;</button></a>
				
				</div>
			</div>
		</div>
    )

}